import { RecurrencePattern } from "./task";
export const touchpointSourceKinds = [
    "sentMessage",
    "smsMessage",
    "voiceCall",
    "calendarEvent",
    "task",
];
export const touchpointKinds = ["email", "call", "text", "visit"];
export const touchpointTypes = [
    "visit",
    "call",
    "text",
    "email",
    "note",
    "event",
    "gift",
];
export const cadenceUnits = [
    RecurrencePattern.Daily,
    RecurrencePattern.Weekly,
    RecurrencePattern.Monthly,
];
//# sourceMappingURL=touchpoint.js.map